window.stringify = (object) => {
  const pairs = [];
  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(object[key]));
    }
  }

  return pairs.length ? pairs.join('&') : '';
};
